import React, { useEffect, useState } from 'react'
import { Box, FormHelperText, InputLabel, makeStyles } from '@material-ui/core';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'

interface PhoneInputProps {
    label: string;
    name: string;
    value: string;
    type: InputPhoneType;
    error: any;
    onChange: (e: any) => void;
    onBlur?: (e: any) => void;
}

export enum InputPhoneType {
    TELEFONE,
    CELULAR
}


const useStyles = makeStyles(() => ({

    inputClass: {
        font: 'inherit',
        cursor: "text",
        color: "rgba(0, 0, 0, 0.87)",
        display: "inline-flex",
        position: "relative",
        fontSize: "1rem !important",
        boxSizing: "border-box",
        alignItems: "center",
        width: "100% !important",
        fontWeight: 400,
        border: "0px !important",
        borderRadius: "0px !important",
        lineHeight: "1.1876em",
        letterSpacing: "0.00938em",
        borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
        '&:hover': {
            borderBottom: "2px solid rgba(0, 0, 0, 0.87) !important"
        },
    },
    buttonClass: {
        border: "0px !important",
        borderRadius: "0px !important",
        borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important',
        '&:hover': {
            borderBottom: "2px solid rgba(0, 0, 0, 0.87) !important"
        },
    }

}));


export default function MuiPhoneInput(props: PhoneInputProps) {

    const { name, label, value, type, error = null, onChange, onBlur } = props;

    const [phoneValue, setPhoneValue] = useState<string>();

    const classes = useStyles();

    const convertToDefEventPara = (name: string, value: any) => ({
        target: {
            name, value
        }
    })

    useEffect(() => {
        setPhoneValue(value);
    }, [value])

    const handleInputChange = (e: any, country: any, event: any, formattedValue: any) => {
        setPhoneValue(formattedValue);
        onChange(convertToDefEventPara(name, formattedValue));
    };

    const handleInputChangeBlur = (e: any) => {
        if (onBlur) {
            onBlur(convertToDefEventPara(name, phoneValue));
        }
    };

    return (
        <React.Fragment>
            <Box mt={1}>
                <InputLabel {...(error && { error: true })} style={{ "color": (!error ? '#000' : '') }}>{label}</InputLabel>

                <PhoneInput
                    country={'br'}
                    inputClass={classes.inputClass}
                    buttonClass={classes.buttonClass}
                    placeholder={"+__ (__) _____ - ____"}
                    autocompleteSearch={true}
                    value={phoneValue}
                    masks={{ br: (type === InputPhoneType.CELULAR ? '(..) .....-....' : '(..) ....-....') }}
                    onChange={handleInputChange}
                    onBlur={handleInputChangeBlur}
                    {...(error && { error: true, helperText: error })}
                />
                <FormHelperText {...(error && { error: true })}>{error}</FormHelperText>
            </Box>
        </React.Fragment >
    )
}


